var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(
              " " +
                _vm._s(_vm.$ct("create-afleveringsbonnen-of-delivered-goods")) +
                " "
            ),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-sale-type-select", {
                        attrs: {
                          "use-id": "",
                          "contact-group-id": _vm.contactGroupId,
                          label: _vm.$ct("target-document-type"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.targetTypeId,
                          callback: function ($$v) {
                            _vm.targetTypeId = $$v
                          },
                          expression: "targetTypeId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }